import { IconActionPlus24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ComparisonLandingImage.css';

export interface IComparisonLandingImageProps {
  url?: string;
  hasAddIcon?: boolean;
}

export const ComparisonLandingImage: React.FC<IComparisonLandingImageProps> = ({ url, hasAddIcon }) => {
  return (
    <div className={styles['container']}>
      {url && <img className={styles['image']} src={url} alt="" loading="lazy" />}
      {!url && hasAddIcon && <IconActionPlus24 color="icon-secondary-disabled" />}
    </div>
  );
};
